/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnInit, signal} from '@angular/core';
import * as _ from 'lodash';

import template from './matching-groups.component.html';

import {TARGETING_IMPORTS} from './targeting-imports';

@Component({
  imports: TARGETING_IMPORTS,
  selector: 'adn-matching-groups',
  template
})
export class MatchingGroupsComponent implements OnInit {
  @Input() targeting: any;
  @Input() targets: any;
  @Input() matchingGroups: any[];
  @Input() matchingGrouped: any;

  groupable: any[] = [];
  readonly disabledMgs = signal<Record<string, boolean>>({});

  ngOnInit(): void {
    this.groupable = _.filter(this.targets, (val: any) => val.groupable);
    this.matchingGroups = this.matchingGroups || [];
    this.matchingGrouped = this.matchingGrouped || {};
    this.refreshDisabledMgs();
  }

  addMg(): void {
    this.matchingGroups.push({mgs: []});
    this.mgSelect();
  }

  deleteMg(index: number): void {
    _.pullAt(this.matchingGroups, index);
    this.mgSelect();
  }

  toggleMg(mg: any, targetsKey: string, event: Event): void {
    const checked = !!(event.target as HTMLInputElement).checked;
    mg.mgs = mg.mgs || [];
    if (checked) {
      if (mg.mgs.indexOf(targetsKey) < 0) {
        mg.mgs.push(targetsKey);
      }
    } else {
      _.pull(mg.mgs, targetsKey);
    }
    this.mgSelect();
  }

  isChecked(mg: any, targetsKey: string): boolean {
    return (mg.mgs || []).indexOf(targetsKey) >= 0;
  }

  isDisabled(mg: any, targetsKey: string): boolean {
    return !!this.disabledMgs()[targetsKey] && !this.isChecked(mg, targetsKey);
  }

  private mgSelect(): void {
    setTimeout(() => {
      this.refreshDisabledMgs();
      this.setUpMatchingGroups();
    }, 80);
  }

  private refreshDisabledMgs(): void {
    const disabledMgs: Record<string, boolean> = {};
    _.forEach(this.matchingGroups, (mg) => {
      _.forEach(mg.mgs, (m: string) => {
        disabledMgs[m] = true;
      });
    });
    this.disabledMgs.set(disabledMgs);
  }

  private setUpMatchingGroups(): void {
    let refMatchingGroups = _.cloneDeep(this.matchingGroups);
    _.forEach(refMatchingGroups, (mg) => {
      mg.mgs = _.filter(mg.mgs, (m) => m);
    });
    refMatchingGroups = _.filter(refMatchingGroups, (val) => {
      return val.mgs && val.mgs.length > 0 && val.mgs[0];
    });

    _.forEach(this.targeting, (t: any) => {
      if (_.isArray(t)) {
        _.forEach(t, (tEl) => {
          delete tEl.matchingGroup;
        });
      } else if (t) {
        delete t.matchingGroup;
      }
    });

    _.forEach(_.keys(this.matchingGrouped), (k) => {
      delete this.matchingGrouped[k];
    });

    _.forEach(refMatchingGroups, (val, index) => {
      _.forEach(val.mgs, (mg: string) => {
        if (_.isArray(this.targeting[mg])) {
          _.forEach(this.targeting[mg], (tEl) => {
            tEl.matchingGroup = index + 1;
          });
        } else if (this.targeting[mg]) {
          this.targeting[mg].matchingGroup = index + 1;
        }
        this.matchingGrouped[mg] = index + 1;
      });
    });
  }
}
